import { FiltersTypes } from "@common/types/filters/general";
import { AccountingReportFilters } from "../types";

type CoaSavedViewFilterKeys =
    | "accountStatus"
    | "accountSource"
    | "accountRolePresence"
    | "accountRulePresence"
    | "accountSubtypes"
    | "form1099Boxes"
    | "coaTemplateGroupKeys";

type CoaSavedViewFilters = Pick<
    AccountingReportFilters,
    CoaSavedViewFilterKeys
>;

/**
 * Page filters a saved view keeps. Search and the entity selection stay
 * session-level, so a view never overrides them.
 */
export function pickCoaViewFilters(filters: CoaSavedViewFilters): FiltersTypes {
    const picked: FiltersTypes = {};
    if (filters.accountStatus !== undefined) {
        picked.accountStatus = filters.accountStatus;
    }
    if (filters.accountSource !== undefined) {
        picked.accountSource = filters.accountSource;
    }
    if (filters.accountRolePresence !== undefined) {
        picked.accountRolePresence = filters.accountRolePresence;
    }
    if (filters.accountRulePresence !== undefined) {
        picked.accountRulePresence = filters.accountRulePresence;
    }
    if (filters.accountSubtypes?.length) {
        picked.accountSubtypes = filters.accountSubtypes;
    }
    if (filters.form1099Boxes?.length) {
        picked.form1099Boxes = filters.form1099Boxes;
    }
    if (filters.coaTemplateGroupKeys?.length) {
        picked.coaTemplateGroupKeys = filters.coaTemplateGroupKeys;
    }
    return picked;
}

/**
 * Every saved-view filter key, unset ones included, so selecting a view
 * clears the filters it does not carry.
 */
export function coaViewFiltersToPageFilters(
    viewFilters: FiltersTypes,
): CoaSavedViewFilters {
    return {
        accountStatus: viewFilters.accountStatus,
        accountSource: viewFilters.accountSource,
        accountRolePresence: viewFilters.accountRolePresence,
        accountRulePresence: viewFilters.accountRulePresence,
        accountSubtypes: viewFilters.accountSubtypes,
        form1099Boxes: viewFilters.form1099Boxes,
        coaTemplateGroupKeys: viewFilters.coaTemplateGroupKeys,
    };
}
